

class Config {
    static isDev = process.env.NODE_ENV === "development";
    static isTest = false;
    static Version = "";

    // variables below can be overruled by loading the config
    static EnableSelectTechnicianRoles = [];
    static AdminRoles = [];

    // link to the DigibonService 
    static DigibonServiceBase = "";     // determined by the environment, may be overruled by a setting in the config.js
    static DigibonServiceBaseDevelopment = "http://localhost:60011/";
    static DigibonServiceBaseTesting = "https://digibonapi.test.nl.careium.com/";
    static DigibonServiceBaseProduction = "https://digibonapi.nl.careium.com/";

    static ApplicationUrl="http://localhost:3000";

    // note:  these are the default application ID's for Careium, these can be overruled in the config.json
    static EntraTenantId = "45041b3f-5f46-4b0b-91d5-20116184c6b0";
    static EntraClientIdDev = "0624fb8d-135d-4570-be68-27234944cbcc";
    static EntraClientIdTest = "0624fb8d-135d-4570-be68-27234944cbcc";
    static EntraClientIdProd = "0624fb8d-135d-4570-be68-27234944cbcc";
    
    // for debugging:  login by using postman and AUTH, then save the token below
    static token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiQWxsYXJkIFBvbGRlcm1hbnMiLCJlbWFpbCI6ImFsbGFyZC5wb2xkZXJtYW5zQGlubm9jb20ubmwiLCJmdWxsTG9naW5OYW1lIjoiREM9aW5ub2NzaVxcYWxsYXJkIiwib2ZmaWNlIjoiNzgzNSIsImp0aSI6IjViY2Y5YTBiLTUzYWItNGFmNi05NDFkLWRkYmQ3OGI2YmI5YiIsInJvbGUiOlsiRGlnaWJvbiBBZG1pbiIsIkNpdHJpeC1GU0xvZ2l4LU9mZmljZSIsIkRpZ2lib24gU3VwZXJ2aXNvciIsIk8zNjUgLSBCdXNpbmVzcyBQcmVtaXVtIiwiQ2l0cml4LU1DUy1Qcm9kdWN0aWUiLCJLYXNwZXJza3kgU2VjdXJpdHkgQXdhcmVuZXNzIiwiQ1NJIFBvcnRhbCIsIkhvdGZvbGRlciAtIFRlY2huaXNjaGVNZWxkaW5nZW4iLCJUb3BkZXNrIiwiTXVsdGktZmFjdG9yIEF1dGhlbnRpY2F0aW9uIiwiRG9rdVdpa2lDb250ZW50IiwiSVQiLCJSZXBhcmF0aWUgVXNlcnMiLCJEZWZhdWx0UHJpbnRlck1GSGVscGRlc2siLCJWUE4gR2VicnVpa2VycyIsIkNpdHJpeC1CdXNpbmVzcyBDb25uZUNUIENsaWVudCIsIkNpdHJpeC1WREkiLCJJbm5vY29tIiwiSGVscGRlc2siLCJUZWNobmlzY2hlIERpZW5zdCJdLCJleHAiOjE3MDE3MDg5NTMsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6NjAwMTAiLCJhdWQiOiJodHRwOi8vbG9jYWxob3N0OjYwMDEwIn0.sxFOMwg76Z-sOwfYzHZ6z265Owf3FtjHeRz_Xsx5ae0";

    static Technicians = []

    // load the config from json
    static load() {
        const url = "config.json?d=" + new Date().valueOf();
        return fetch(url)
            .then((r) => r.json())
            .then((data) => {
                // set the configured DigibonServiceBase reference
                if (Config.isDev) {
                    Config.DigibonServiceBase = Config.DigibonServiceBaseDevelopment;
                } else if (data.Environment === "testing") {
                    Config.isTest = true;
                    Config.DigibonServiceBase = Config.DigibonServiceBaseTesting;
                    Config.ApplicationUrl= data.ApplicationUrlTesting;
                } else {
                    Config.DigibonServiceBase = Config.DigibonServiceBaseProduction;
                    Config.ApplicationUrl=  data.ApplicationUrlProduction;
                }

                // check if there is a overrule for the DigibonServiceBase in the config 
                if (data.DigibonServiceBase) {
                    Config.DigibonServiceBase = data.DigibonServiceBase;
                }
                Config.EnableSelectTechnicianRoles = data.EnableSelectTechnicianRoles;
                Config.AdminRoles = data.AdminRoles;
                if (data.EntraTenantId) Config.EntraTenantId = data.EntraTenantId;
                if (data.EntraClientId) {
                    Config.EntraClientIdDev= data.EntraClientId;
                    Config.EntraClientIdTest= data.EntraClientId;
                    Config.EntraClientIdProd= data.EntraClientId;
                }
                
                console.log("Application URL", Config.ApplicationUrl);
                console.log("data loaded", data);
                return data;
            });
    }

    static async loadVersion() {
        const url = "version.json?d=" + new Date().valueOf();
        
        return fetch(url)
            .then((r) => { var s = r.json(); return s; })
            .then((data) => {
                Config.Version =data.version;
            });
    }

    static loadTechnicians() {
        const url = Config.DigibonServiceBase + "technicians";
        fetch(url, Config.GetBearer())
            .then((res) => { return res.ok ? res.json() : { status: res.status } })
            .then((json) => {
                Config.Technicians = json;
            }).catch((error) => {

            });
    }

    static isEnableSelectTechnician(jwtToken) {
        if (!jwtToken.role || !jwtToken.role.find) return false;
        if (jwtToken.role.find(p => this.EnableSelectTechnicianRoles.some(function (e) { return e === p; }))) {
            return true;
        }
        return false;
    }

    static isAdmin(jwtToken) {
        if (!jwtToken.role || !jwtToken.role.find) return false;
        if (jwtToken.role.find(p => this.AdminRoles.some(function (e) { return e === p; }))) {
            return true;
        }
        return false;
    }

    static isWarehouseRole(jwtToken) {
        if (!jwtToken.role || !jwtToken.role.find) return false;
        if (jwtToken.role.find(p => this.WarehouseRoles.some(function (e) { return e === p; }))) {
            return true;
        }
        return false;
    }

    static GetBearer() {
        return {

            headers: {
                'Authorization': 'Bearer ' + Config.token
            }
        }
    }

    static GetBearerPost(postData) {
        return {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + Config.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData)
        }
    }
    static GetBearerDelete() {
        return {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + Config.token
            }
        }
    }
    static GetEntraClientId() {
        if (this.isDev) {
            return this.EntraClientIdDev;
        } else if (this.isTest) {
            return this.EntraClientIdTest;
        } else {
            return this.EntraClientIdProd;
        }
    }
    static GetEntraTenantId() {
        return this.EntraTenantId;
    }
    static GetEntraRedirect() {
        return this.ApplicationUrl;
    }
}

export default Config;